import { createFileRoute, Outlet, useChildMatches } from '@tanstack/react-router'
import { SettingsScreen } from '@/features/settings/settings'

/**
 * Route shell for the platform settings screen — plan 05 Task 13.
 *
 * Per the route-shell rule, this file is a route definition and a render.
 * The screen lives in `src/features/settings/`.
 */
export const Route = createFileRoute('/_authenticated/settings')({
  component: SettingsRoute,
})

function SettingsRoute() {
  const children = useChildMatches()

  if (children.length > 0) {
    return <Outlet />
  }

  return <SettingsScreen />
}
